var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 15.881621 15.88162",
    width: 15.88162,
    height: 15.88162,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.35355338,
    y1: 15.528067,
    x2: 15.528068,
    y2: 0.35355338,
    id: "line6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.35355386,
    y1: 0.35355359,
    x2: 15.528068,
    y2: 15.528067,
    id: "line6-4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroix);
export default __webpack_public_path__ + "static/media/croix.e521576cedce61263094acfd6330a8bc.svg";
export { ForwardRef as ReactComponent };